import { render, staticRenderFns } from "./ProductControls.vue?vue&type=template&id=121ed7e7&scoped=true&"
import script from "./ProductControls.vue?vue&type=script&lang=js&"
export * from "./ProductControls.vue?vue&type=script&lang=js&"
import style0 from "./ProductControls.vue?vue&type=style&index=0&id=121ed7e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ed7e7",
  null
  
)

export default component.exports